import type { Node } from '@babylonjs/core/node';

/** Restore an appended node's slot only if every other child still matches the expected order. */
export function restoreChildSlot(node: Node, parent: Node, order: readonly Node[]): void {
    const children = (parent as unknown as { _children: Node[] | null })._children;
    const slot = order.indexOf(node);
    if (!children || slot < 0 || slot === order.length - 1) return;
    if (children.length !== order.length || children[children.length - 1] !== node) return;
    for (let i = 0; i < children.length - 1; i++) {
        if (children[i] !== order[i < slot ? i : i + 1]) return;
    }
    // In place: `_children` holds no index caches (unlike scene.rootNodes).
    children.pop();
    children.splice(slot, 0, node);
}
